import { IDispatchProps, IFormData } from './interfaces'
import { ActivityItems, ActivityUpdateItem, ITimelineResponse } from '../../components/v2/activity-timeline'

export const CLAIM_WORK_FORM_LOADING = 'CLAIM_WORK_FORM_LOADING'
export const CLAIM_WORK_DATA = 'CLAIM_WORK_DATA'
export const CLAIM_WORK_FORM_FAILED = 'CLAIM_WORK_FORM_FAILED'
export const CLAIM_WORK_FORM_ALERT = 'CLAIM_WORK_FORM_ALERT'
export const CLAIM_WORK_FORM_ID_UPDATE = 'CLAIM_WORK_FORM_ID_UPDATE'
export const CLAIM_WORK_TIMELINE_LOADING = 'CLAIM_WORK_TIMELINE_LOADING'
export const CLAIM_WORK_TIMELINE_DATA = 'CLAIM_WORK_TIMELINE_DATA'
export const CLAIM_WORK_TIMELINE_FAILED = 'CLAIM_WORK_TIMELINE_FAILED'
export const CLAIM_WORK_TIMELINE_CLEAR = 'CLAIM_WORK_TIMELINE_CLEAR'
export const CLAIM_WORK_TIMELINE_ADD_ITEM = 'CLAIM_WORK_TIMELINE_ADD_ITEM'
export const CLAIM_WORK_TIMELINE_UPDATE_ITEM = 'CLAIM_WORK_TIMELINE_UPDATE_ITEM'
export const CLAIM_WORK_TIMELINE_DELETE_ITEM = 'CLAIM_WORK_TIMELINE_DELETE_ITEM'
export const CLEAR_CLAIM_WORK_DATA = 'CLEAR_CLAIM_WORK_DATA'

/* ============== CLAIM_FORM ============== */
export function setClaimWorkFormLoading() {
  return async dispatch => {
    dispatch({ type: CLAIM_WORK_FORM_LOADING })
  }
}

export function clearClaimWorkData() {
  return async dispatch => {
    dispatch({ type: CLEAR_CLAIM_WORK_DATA })
  }
}

export function setClaimWorkFormData(data: IFormData) {
  return async dispatch => {
    dispatch({ type: CLAIM_WORK_DATA, payload: data })
  }
}

export function setClaimWorkFormFailed(error: string) {
  return async (dispatch: IDispatchProps) => {
    dispatch({ type: CLAIM_WORK_FORM_FAILED, payload: error })
  }
}

export function setClaimWorkFormAlert(alert?: null | string) {
  return async dispatch => {
    dispatch({ type: CLAIM_WORK_FORM_ALERT, payload: alert })
  }
}
export function setClaimWorkId(id: string) {
  return async dispatch => {
    dispatch({ type: CLAIM_WORK_FORM_ID_UPDATE, payload: id })
  }
}
/* ============== end Claim_FORM ============== */

/* ============== Claim_TIMELINE ============== */
export function setClaimWorkTimelineLoading() {
  return async dispatch => {
    dispatch({ type: CLAIM_WORK_TIMELINE_LOADING })
  }
}

export function setClaimWorkTimelineData(formData: ITimelineResponse) {
  return async dispatch => {
    dispatch({ type: CLAIM_WORK_TIMELINE_DATA, payload: formData })
  }
}

export function setClaimWorkTimelineFailed(error: string) {
  return async dispatch => {
    dispatch({ type: CLAIM_WORK_TIMELINE_FAILED, payload: error })
  }
}

export function setClaimWorkTimelineClear() {
  return async dispatch => {
    dispatch({ type: CLAIM_WORK_TIMELINE_CLEAR })
  }
}

export function addClaimWorkTimeLineItem(activityItems: ActivityItems[]) {
  return async dispatch => {
    dispatch({ type: CLAIM_WORK_TIMELINE_ADD_ITEM, payload: activityItems })
  }
}

export function updateClaimWorkTimeLineItem(activityItem: ActivityUpdateItem) {
  return async dispatch => {
    dispatch({ type: CLAIM_WORK_TIMELINE_UPDATE_ITEM, payload: activityItem })
  }
}

export function deleteClaimWorkTimeLineItem(activityItem: ActivityUpdateItem) {
  return async dispatch => {
    dispatch({ type: CLAIM_WORK_TIMELINE_DELETE_ITEM, payload: activityItem })
  }
}
/* ============== end Claim_TIMELINE ==============  */
